import { useQuery } from "@apollo/client";
import { gql } from "generated-graphql";
import { ReportingFacilityChemicalDialog } from "./ReportingFacilityChemicalDialog";

export const REPORTING_FACILITY_CHEMICAL_QUERY = gql(`
  query ReportingFacilityChemical($id: ID!, $reportId: ID) {
    reportingFacilityChemical(id: $id, reportId: $reportId) {
      id
      facilityId
      aggregationErrorMessage
      aggregationError
      maxAmount
      unit
      averageAmount
      isOverThreshold
      chemicalId
      reportingYear
      hasConfidentialStorageLocations
      isAlwaysReported
      ...ReportingFacilityChemicalAggregate
      manuallyEdited
      chemical {
        ...FacilityChemicalChemical
        noHazardsNotReporting
      }
      storageLocations {
        ...ReportingFacilityChemicalStorageLocationForm
      }
      issues {
        ...issue
      }
      previousYearMaxAmount {
        amount
        unit
      }
      jurisdictions
      stateFields {
          key
          value
          type
          jurisdiction
          inputType
          label
          tooltip
          group
          selectOptions {
            label
            value
          }
      }
      maxAmountProductChemicalBreakdown {
        productMaxAmount {
          amount
          unit
        }
        chemicalMaxAmount {
          amount
          unit
        }
      }
      thresholdResults {
        description
        threshold
        unit
        overThreshold
        isSection312
        isSection302
        type
      }
      origin {
        facilityChemicalId
        facilityProducts {
          id
          daysOnSite
          maxQuantity
          averageQuantity
          product {
            id
            name
            productChemicals {
              amount
              chemicalId
            }
          }
        }
        facilityProductMeasurements {
          id
          quantity
          measuredAtUtc
          product {
            id
            name
            productChemicals {
              id
              chemicalId
              amount
              unit
            }
          }
        }
        facilityChemicalMeasurements {
          id
          measuredAtUtc
          endDate
          amount
          unit
          storageType
          maxAmountLargestContainer
          storageLocation {
            description
            OR_storageBuilding
          }
        }
      }
    }
  }
`);

export const ReportingFacilityChemicalEditor = ({
  id,
  reportId,
  onClose,
}: {
  id: string;
  reportId?: string;
  onClose: () => void;
}) => {
  const { data, loading } = useQuery(REPORTING_FACILITY_CHEMICAL_QUERY, {
    variables: { id, reportId },
    fetchPolicy: "cache-and-network",
  });

  return (
    <ReportingFacilityChemicalDialog
      rfc={data?.reportingFacilityChemical}
      loading={loading}
      onClose={onClose}
    />
  );
};
